
  $('.contact-btn').click(function(e) {
    e.preventDefault();
    sendForm($('#contactform'));
  });
  $('[name = Name]').on('change', function ()    { resetFormField('Name', 'Your name:'); });
  $('[name = Email]').on('change', function ()   { resetFormField('Email', 'Your email address:'); });
  $('[name = Message]').on('change', function () { resetFormField('Message', 'What is your message?'); });
  $('[name = Subject]').on('change', function () { resetFormField('Subject', 'I want to talk about:'); });

function resetFormField($id, $message) {
  $("#"+$id+"Label").removeClass('form-error');
  $("#"+$id+"Label").html($message);
}

function sendForm($formName) {
  var data = $($formName).serialize();
  $.ajax({
    type: "POST",
    data: data,
    url: "/contact"
  })
  .done(function(data) {
      var errorCount = data.errorCount;
      if (errorCount > 0) {
          $.each(data, function(key, value) {
              var firstValue = value.toString().split(',')[0];
              $('#' + key + 'Label').html(firstValue).addClass('form-error');
          });
      } else {
          showConfirmation();
      }
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
      // Handle error here
  });
}
      //$('.form-error').first().parent().siblings('.form-field').find('input, select').first().focus()
function showConfirmation() {
    $('#contact-main').hide();
    $('.message-confirmation').removeClass('hidden');
}

// contact form hint dropdown functionality
$(function() {
    // add event listener to select element
    $('select[name="Subject"]').on('change', function() {
        // get the selected value
        var selectedValue = $(this).val();
    
        // hide both hints first
        $('.loan-hint').hide();
        $('.card-hint').hide();
        
        // show the corresponding hint based on selected value
        if (selectedValue === 'loans') {
            $('.loan-hint').slideDown('250').removeClass('hidden');
        } else if (selectedValue === 'credit_card') {
            $('.card-hint').slideDown('250').removeClass('hidden');
        }
    });
});

$('#getintouch').on('click', function(e) {
    e.preventDefault();
    $('#getintouch-container').addClass('hidden');
    $('#contact-filter').fadeIn(600);
});